export const TOGGLE_APP_DRAWER_MUTATION = 'TOGGLE_APP_DRAWER_MUTATION'
export const SET_DRAWER_STATE_MUTATION = 'SET_DRAWER_STATE_MUTATION'
export const SET_ERROR_RESPONSE_DIALOG_DATA = 'SET_ERROR_RESPONSE_DIALOG_DATA'

//<editor-fold desc="Auth Module Mutations">
export const AUTH_SET_CURRENT_USER_MUTATION = 'AUTH_SET_CURRENT_USER_MUTATION'
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN'
export const SET_INVALID_TOKEN_MUTATION = 'SET_INVALID_TOKEN_MUTATION'
//</editor-fold>

export const SET_DATA_CHANGED = 'SET_DATA_CHANGED'

//DAILY MENU
export const SET_CURRENT_DAILYMENU = 'SET_CURRENT_DAILYMENU'
export const SET_SELECTED_DAILYMENU_TEMPLATE = 'SET_SELECTED_DAILYMENU_TEMPLATE'
export const SET_SELECTED_DAILYMENU_VIEW = 'SET_SELECTED_DAILYMENU_VIEW'
export const SET_LOADING_DAILYMENU = 'SET_LOADING_DAILYMENU'
export const SET_SEARCHED_FOOD = 'SET_SEARCHED_FOOD'

//RESERVATION PAGE
export const SET_LOADING_RESERVATION = 'SET_LOADING_RESERVATION'
export const SET_CURRENT_RESERVATION = 'SET_CURRENT_RESERVATION'
export const SET_CURRENT_RESERVATION_HEADER = 'SET_CURRENT_RESERVATION_HEADER'

export const SET_CURRENT_USER_DAILYMENU = 'SET_CURRENT_USER_DAILYMENU'
export const SET_CURRENT_DAILYMENU_OFFER = 'SET_CURRENT_DAILYMENU_OFFER'
export const SET_CURRENT_DAILYMENU_TOP_GROUP_OFFER = 'SET_CURRENT_DAILYMENU_TOP_GROUP_OFFER'
export const SET_DAILYMENU_TOP_GROUP_OFFER_CHANGE_SET = 'SET_DAILYMENU_TOP_GROUP_OFFER_CHANGE_SET'
export const SET_DAILYMENU_OFFER_CHANGE_SET = 'SET_DAILYMENU_OFFER_CHANGE_SET'
export const SET_CURRENT_USER_RESERVATION_RANGE_DATA = 'SET_CURRENT_USER_RESERVATION_RANGE_DATA'
export const SET_DAILY_MENU_TOP_GROUP_SAVED = 'SET_DAILY_MENU_TOP_GROUP_SAVED'
export const SET_USER_SETTINGS_4_ORDERING = 'SET_USER_SETTINGS_4_ORDERING'

export const SET_CALENDAR_EVENTS = 'SET_CALENDAR_EVENTS'
export const SET_LOADING_WEEKCALENDAR = 'SET_LOADING_WEEKCALENDAR'
export const SET_CURRENT_UI_LANGUAGE = 'SET_CURRENT_UI_LANGUAGE'

export const SET_SMART_LINK_FILTER_MUTATION = 'SET_SMART_LINK_FILTER_MUTATION'







